import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Box, Container, Grid, Typography, Divider } from '@mui/material';

import { getCurrentRequirement } from '../../../../actions/requirementsActions';
import { resetRequirementsState } from '../../../../slices/requirementsSlice';

const styles = {
  title: {
    marginBottom: '1rem'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #ccc',
    padding: '50px 20px 50px 20px',
    borderRadius: '8px',
    marginTop: '30px',
    marginBottom: '30px'
  }
}

const RequirementDetails = () => {
  const messagesContainer = useRef();

  const params = useParams();

  const dispatch = useDispatch();

  const current = useSelector(state => state.requirements.current);

  const scrollToBottom = () => {
    messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight;
  }

  useEffect(() => {
    dispatch(getCurrentRequirement({ id: params.id, callback: scrollToBottom }));
    return () => dispatch(resetRequirementsState())
  }, []);

  return (
    <>
      <Helmet>
        <title>Cristopher | Requerimiento </title>
      </Helmet>
      <Box sx={styles.box}>
        <Container ref={messagesContainer} sx={{ flex: 1, overflowY: 'scroll', maxHeight: { xs: '70vh', md: '75vh' } }}>
          <Typography variant="h5" sx={styles.title} fontWeight="bold">Requerimiento: {current.subject ?? params.id}</Typography>
          <Grid container spacing={2} >
            <Grid item xs={12} md={6}>
              <Typography variant="h6">Nombre: {current.name}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Documento de Identidad: {current.documentId}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Celular: {current.phone}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Cargo: {current.position}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Correo de Notificación: {current.notificationEmail}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">ID de Solicitud: {current.requestId}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6">Ciudad: {current.city}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Tipo de Prueba: {current.testType}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Cliente: {current.client}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Centro de Costos: {current.costCenter}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Estado de la Prueba: {current.testStatus}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
              <Typography variant="h6">Evidencia: {current.evidence}</Typography>
              <Box sx={styles.dividerBox}><Divider /></Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default RequirementDetails;
